import { decodeToken } from './oidc'

export const isAuthenticated = (idToken) => {
  const decodedToken = decodeToken(idToken)
  if (decodedToken === null) {
    return false
  }
  if ((decodedToken.exp * 1000) <= Date.now()) {
    return false
  } else {
    return true
  }
}

export const getProfile = (idToken) => {
  const decodedToken = decodeToken(idToken)
  if (decodedToken === null) {
    return null
  } else {
    return decodedToken
  }
}

export const networkNavLinks = (activatedClients, theme) => {
  if (activatedClients && activatedClients.includes(theme.clientId || theme.name)) {
    return theme.loggedInLinks
  } else {
    return theme.links
  }
}



// WEBPACK FOOTER //
// ./src/tools/user.js